import i18n from "i18n";
const notificationTypeTitle = (plugin) => (plugin == null ? void 0 : plugin.displayNameKey) ? i18n.t(plugin.displayNameKey) : plugin == null ? void 0 : plugin.displayName;
export default notificationTypeTitle;
